export const GET_WORKS = "GET_WORKS";
export const GET_LIST_WORKS = "GET_LIST_WORKS";
export const GET_WORK = "GET_WORK";
export const SET_WORKS = "SET_WORKS";
export const SET_REPEATED_WORKS = "SET_REPEATED_WORKS";
export const SET_LIST_WORKS = "SET_LIST_WORKS";
export const SET_WORK = "SET_WORK";
export const ADD_WORK = "ADD_WORK";
export const SET_NEW_WORK = "SET_NEW_WORK";
export const EDIT_WORK = "EDIT_WORK";
export const SET_EDIT_WORK = "SET_EDIT_WORK";
export const SET_DELETE_WORK = "SET_DELETE_WORK";
export const SET_DELETE_MULTI_WORK = "SET_DELETE_MULTI_WORK";
export const SET_DELETE_REPEATED_WORK = "SET_DELETE_REPEATED_WORK";
export const SET_DELETE_REPEATED_MULTI_WORK = "SET_DELETE_REPEATED_MULTI_WORK";
export const DELETE_WORK = "DELETE_WORK";
export const DELETE_MULTI_WORK = "DELETE_MULTI_WORK";
export const RESET_ITEMS_WORK = "RESET_ITEMS_WORK";
export const RESET_SELECTED_WORK = "RESET_SELECTED_WORK";
export const RESET_LIST_WORKS = "RESET_LIST_WORKS";
export const RESET_REPEATED_WORKS = "RESET_REPEATED_WORKS";
